import DynamicForm from "components/DynamicForm";
import {useEffect, useState } from "react";
import "./index.scss";
import Label from "lib/Label";
import { useSelector, useDispatch } from "react-redux";
import {
  setAddSavedFormFields,
  setAddSaveData,
  setRecursiveFormData,
  setDeleteSaveData,
  setDeleteFormFields,
  setEditIndex,
  setFieldRecursiveName,
  clearFieldRecursionData,
} from "redux/fieldRecursiveReducer";
import { Modal, Row, Col } from "react-bootstrap";
import { ButtonV1 } from "lib";
import { formGenerator } from "helper/formGenerator";
import { createSupportingDocumentsConfig } from "api/supportingDocuments";
import {DropdownV1} from "../../lib"

const RequestSupportingDocuments = (props) => {
  const {
    selectedData,
    inputFields,
    recursiveActions,
    recursiveTitle,
    formErr,
    clearFieldError,
    // minLength,
    // maxLength,
    assignee_required,
    request_change_option,
    user,
    role,
    notification
  } = props;
    
  const inputField = inputFields[0];
  const [comment, setComment] = useState("");
  const [dropdownV1Value, setDropdownV1Value] = useState({})
  const [selectedUser,setSelectedUser] = useState({})
  const all_users = useSelector((state)=> state.dashboardReducer?.allUsers)
  const formData = useSelector((state) => state.formData);
  const formField = useSelector(
    (state) => state?.fieldRecursiveReducer?.savedFormFields
  );
  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)
  // const editIndex = useSelector(
  //   (state) => state?.fieldRecursiveReducer?.editIndex
  // );
  const dispatch = useDispatch();
  const selectedFormData = useSelector((state) => state.formData?.selectedData);

  const savedFormFields = useSelector(
    (state) => state?.fieldRecursiveReducer?.savedFormFields
  );

  const saveData = useSelector(
    (state) => state?.fieldRecursiveReducer?.saveData
  );

  const profileData = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  )?.profileInfo;

  const dashboardDetailData = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.dashboardDetailData?.subworkFlowInfo
  );

  const guardianData = useSelector((state) =>
    state?.dashboardDetailReducer?.dashboardDetailData?.subworkflows?.filter(
      (item) => item?.workflow_type === "guardian" || item?.guardian_of
    )
  );

  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );

  const primaryWorkflowID = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.userSubworkFlowInfo?.primary_workflow_id
  );

  const organisation_id = useSelector(
    (state)=> state?.loggedInUserInfo?.userAuthInfo
  ).organisationInfo?._id

  const workFlowCreatedBy = useSelector((state)=>state?.dashboardDetailReducer.workFlowInfo.created_by)


  const [doesAllDocumentsHasLabel, setDoesAllDocumentsHasLabel] = useState("");

  useEffect(() => {
    dispatch(clearFieldRecursionData());
    if (formData?.selectedData[recursiveTitle]) {
      let recursiveObj = { ...formData?.selectedData[recursiveTitle] };
      if (formData?.selectedData[recursiveTitle]?.length === 0) {
        dispatch(
          setAddSavedFormFields({
            ...inputField,
            id: inputField.id + `_${formField.length}`,
            name: inputField.name + `_${formField.length}`,
            value: {}, // default value
            index: 0,
          })
        );
        dispatch(
          setAddSaveData({
            id: inputField.id + `_${formField.length}`,
            name: inputField.name + `_${formField.length}`,
            value: {}, // default value
          })
        );
        dispatch(setEditIndex(0));
      }
      Object.keys(recursiveObj).map((_item) => {
        let item = recursiveObj[_item];
        dispatch(
          setAddSavedFormFields({
            ...inputField,
            id: item.id,
            name: item.name,
            value: item.value,
          })
        );
        dispatch(
          setAddSaveData({
            id: item.id,
            name: item.name,
            value: item.value,
          })
        );
      });
    } else {
      dispatch(
        setAddSavedFormFields({
          ...inputField,
          id: inputField.id + `_${formField.length}`,
          name: inputField.name + `_${formField.length}`,
          value: {}, // default value
          index: 0,
        })
      );
      dispatch(
        setAddSaveData({
          id: inputField.id + `_${formField.length}`,
          name: inputField.name + `_${formField.length}`,
          value: {}, // default value
        })
      );
      dispatch(setEditIndex(0));
    }
    dispatch(setFieldRecursiveName(recursiveTitle));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddMore = async () => {
    dispatch(
      setAddSaveData({
        id: inputField.id + `_${formField.length}`,
        name: inputField.name + `_${formField.length}`,
        value: {}, // giving default values
      })
    );
    dispatch(
      setAddSavedFormFields({
        ...inputField,
        id: inputField.id + `_${formField.length}`,
        name: inputField.name + `_${formField.length}`,
        value: {},
      }) 
    );
  };

  const handleDelete = (e, index) => {
    dispatch(setDeleteFormFields(index));
    dispatch(setDeleteSaveData(index));
  };

  const handleOnFocus = (index) => {
    dispatch(setEditIndex(index));
  };

  const handleSupportingDocuments = () => {
    if (savedFormFields?.length === 0 || saveData?.length === 0) {
      setDoesAllDocumentsHasLabel("Please add atleast one document");
    } else if (savedFormFields.length === saveData.length) {
      // in save data array we have object , in that even if one object has empyt text for value.textthen return false
      let HasLabel = saveData.every((item) => {
        return (
          item.value.text !== "" &&
          item.value.text !== undefined &&
          item.value.text !== null
        );
      });
      if (HasLabel) {
        const input_ele =
          savedFormFields?.length &&
          savedFormFields.map((item) => {
            return {
              type: "upload",
              label: item.value.text,
              name: item.name,
              show: true,
              is_required: !item.value.is_required,
              maxSize: 10000000.0,
            };
          });
          let primary_gaurdian_data=null;
          if(guardianData?.length>0){
            [primary_gaurdian_data] = guardianData;
          }
          setDoesAllDocumentsHasLabel("");
        const form = formGenerator(input_ele);
        dispatch(clearFieldRecursionData());
        let name;
        let email_address;
        let subWorkflowId;
        
        if (dashboardDetailData?.majority === "Minor") {
          const guardianData = primary_gaurdian_data || dashboardDetailData;
          name = guardianData?.last_name 
            ? `${guardianData?.first_name} ${guardianData?.last_name}` 
            : guardianData?.first_name;
          email_address = guardianData?.email;
          subWorkflowId = currentSubWorkFlowId || primary_gaurdian_data?._id;
        } else {
          name = dashboardDetailData?.last_name 
            ? `${dashboardDetailData?.first_name} ${dashboardDetailData?.last_name}` 
            : dashboardDetailData?.first_name;
          email_address = dashboardDetailData?.email;
          subWorkflowId = currentSubWorkFlowId;
        }
        
       
        const obj = {
          organisation_id: organisation_id,
          form_elements: form,
          user_name: assignee_required == 'true' ? selectedUser?.first_name + ' ' +selectedUser?.last_name  : name,
          user_email: assignee_required == 'true' ? selectedUser?.email_id  : email_address,
          subworkflow_id: subWorkflowId,
          comment: comment,
          workFlowId: primaryWorkflowID,
          createdBy: profileData?.userId,
          createdusername:
            profileData?.first_name + " " + profileData?.last_name,
          // has_link_expiry: organisationInfo?.has_link_expiry,
          hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
          assignee_required:assignee_required
        };

        dispatch(createSupportingDocumentsConfig(obj));

        props.onHide();
      } else {
        setDoesAllDocumentsHasLabel("Please add a label to all the documents");
      }
    } else {
      setDoesAllDocumentsHasLabel("");
    }
  };
 
  const dropdownv1OnChange=(e)=>{
    const { name, value } = e.target;
    let obj ={}
    if (request_change_option === "role") {
      let userList;
      if(user?.includes('creator')){
          userList= all_users.filter(
          (obj) => (obj?.role === value&&obj?._id===workFlowCreatedBy)
        )
      }else{
        userList= all_users.filter(
        (obj) => obj?.role === value
      );
      }
     
      let profileDetails = userList.map(({ _id, profile, email_id,mobile_number }) => ({ _id, profile, email_id ,mobile_number}));
      // obj = {
      //   profileData: profileDetails,
      // };
      obj = {
        ...profileDetails[0]?.profile,
        email_id: profileDetails[0]?.email_id,
        mobile_number: profileDetails[0]?.mobile_number,
        _id: profileDetails[0]._id,
      };
     
    } else {
      let selected_user = all_users.filter((e) => {
        return e._id == value;
      });
      if (selected_user?.length) {
        selected_user = selected_user[0];
        obj = {
          ...selected_user?.profile,
          email_id: selected_user?.email_id,
          mobile_number: selected_user?.mobile_number,
          _id: selected_user._id,
        };
      }
    }
   
    setSelectedUser(obj)
    setDropdownV1Value({[name] : value})
  }
  return (
    <>
      <Modal
        size="md"
        className="modal_s"
        show={props.show}
        onHide={props.onHide}
        scrollable
        centered
        backdrop="static"
        // style={{
        //   padding: "2rem",
        //   width: "45vw",
        //   marginLeft: "30vw",
        // }}
      >
        <Modal.Header closeButton className="modal_headers m-2 mb-0">
          <Modal.Title className="req_change_title text-theme fs-20px fw-bold">
            Request supporting documents
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
         className="px-4">
          <div className="multi_ddConatiner px-2">
            Check the checkbox to make the document upload optional
          </div>
          <div className="px-2">
            <Label label={`${inputField?.label}`} />

            {formField &&
              formField?.map((item, index) => {
                //Showing the already filled data values
                return (
                  <div
                    className="mx-2 requestdOCfIELDsTYLE"
                    onFocus={() => handleOnFocus(index)}
                    key={index}
                    // style={{
                    //   // width: "90%",
                    //   display: "flex",
                    //   flexDirection: "row",
                    //   alignItems: "center",
                    //   justifyContent: "space-evenly",
                    // }}
                  >
                    <DynamicForm
                      formErr={formErr}
                      clearFieldError={clearFieldError}
                      setSelectedData={setRecursiveFormData}
                      selectedData={
                        item.type === "upload"
                          ? selectedFormData
                          : formField[index]
                      }
                      formButtons={recursiveActions}
                      recursiveFormButtons={recursiveActions}
                      formFields={item}
                      
                    />
                    {/* <button
                    
                      onClick={(e) => handleDelete(e, index)}
                      type="button"
                      className="handleDeleteRequestDocstyleChnages"
                      class="btn-close"
                      aria-label="Close"
                      title="Delete"
                      style={{
                        margin: "5px",
                        padding: "5px",
                        marginBottom: "20px",
                        cursor: "pointer",
                      }}
                    ></button> */}
                    <span className="">
                      <button
                        onClick={(e) => handleDelete(e, index)}
                        class="btn-close mb-3 ms-1"
                      >
                      </button>
                    </span>
                  </div>
                );
              })}
            {/* <FormButton
            formButtons={recursiveActions}
            handleFieldAddMore={handleAddMore}
            className="field_button"
          /> */}
            {doesAllDocumentsHasLabel && (
              <div className="errorLabeled">
                {doesAllDocumentsHasLabel
                  ? doesAllDocumentsHasLabel
                  : "Please enter the name for the requested documents"}
              </div>
            )}
            <div className="add_new" onClick={() => handleAddMore()}>
              <i class="fa-regular fa-square-plus"></i> Add New
            </div>
          </div>
          <Row className=" px-3 mt-3 mb-3">
            <div
              // style={{
              //   fontSize: "13px",
              //   padding: "0px 0px 0px 0px",
              // }}
              className="comments_head commentsTextRequestchangeStyle"
            >
              Comments(optional)
            </div>
            <input
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              type="text"
              className="w-100 border border-1 border-black h-35px"
            />
          </Row>
          {assignee_required && assignee_required == 'true' ? <Row className="row_comments_heading mx-0 mt-4">
          <DropdownV1 
              options_type = {"all_users"}
              label = {"Assignee"}
              onChange = {dropdownv1OnChange}
              name = {"user_assignee"}
              value = {dropdownV1Value}
              selectedData = {dropdownV1Value}  
              isEditable ={true}
              size={'px-0'}
              request_change_option ={request_change_option}
              role = {role}
              user = {user}
              notification = {notification}
             
              workFlowCreatedBy={workFlowCreatedBy}
           />
        </Row> : '' }
          <Row className="buttons_conatiner">
            <Col lg={6} xs={6} onClick={props.onHide} className="backButton">
              Back
            </Col>
            <Col lg={6} xs={6} className="send_button">
              {" "}
              <ButtonV1
                label="Send"
                className="primary_button"
                disabled={!(assignee_required == 'true' ? dropdownV1Value.hasOwnProperty('user_assignee')? dropdownV1Value['user_assignee'].length != 0 : false : true)}
                onClick={handleSupportingDocuments}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default RequestSupportingDocuments;
